module.exports = __webpack_public_path__ + "img/@contact_bnr2.3563286e.jpg";